export enum StudyProfileStatus {
  Pending = 1,
  Archived = 2,
  Canceled = 3,
  Closeout = 4,
  Enrolling = 5,
  MaintenanceEnrollmentClosed = 6,
  OnHold = 7,
  Postponed = 8,
  ProtocolFinal = 9,
  Randomizing = 10,
  ScreeningRecruiting = 11,
  StartUp = 12,
}
